import React, { useLayoutEffect, useRef, useState } from 'react';

import { makeStyles, Tooltip } from '@material-ui/core';

import { Container, OverflowTextBody } from './styles';

interface OverflowTextProps {
  title: string;
  children: React.ReactNode;
  style?: React.CSSProperties | undefined;
  lines?: number;
  orientation?: 'vertical' | 'horizontal';
  tooltipPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  isInteractive?: boolean;
}

const useStyles = makeStyles(() => ({
  popper: {
    zIndex: 99999,
  },
}));

const OverflowText: React.FC<OverflowTextProps> = ({
  title,
  children,
  style,
  lines,
  orientation,
  tooltipPlacement,
  isInteractive = true,
}) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const ref = useRef<any>(null);

  useLayoutEffect(() => {
    const { scrollHeight, clientHeight } = ref.current;
    setIsOverflowing(scrollHeight > clientHeight);
  }, [ref]);

  const classes = useStyles();

  return (
    <Container>
      <Tooltip
        interactive={isInteractive}
        disableHoverListener={!isOverflowing}
        title={title}
        arrow
        placement={tooltipPlacement}
        classes={classes}
      >
        <OverflowTextBody
          lines={lines}
          orientation={orientation}
          style={style}
          ref={ref}
        >
          {children}
        </OverflowTextBody>
      </Tooltip>
    </Container>
  );
};
export default OverflowText;
